import { breakpoints, matchBreakpoint } from "../common/utils";
let isDesktop = false;
const checkDevices = () => {
  matchBreakpoint(breakpoints.lg, "min")
    ? (isDesktop = true)
    : (isDesktop = false);
};

const initMenuDesktop = () => {
  let nodeTimeout;
  const header = $("[data-sticked-header]");
  const submenu = $(".c-main-navigation__submenu");
  const constants = {
    listActive: "active"
  };
  const opanSubNav = $("[data-opensub-nav]");
  const openSubNavUl = $("[data-opensub-nav] ul");
  const closeSubnavOnDocument = ($thisOne = "") => {
    opanSubNav.removeClass(constants.listActive);
    if (isDesktop) {
      $("body").removeClass("scrollLock");
      submenu
        .not($thisOne)
        .fadeOut(150)
        .promise()
        .done(() => {
          submenu.removeClass(constants.listActive);
        });
    } else {
      submenu.removeAttr("style");
    }
  };

  const openSubNavFv = event => {
    const loggedInAdjustHeight = $("body").hasClass("logged-in") ? 32 : 0;
    const that = $(event.currentTarget);
    const headerHeight = header.outerHeight() + loggedInAdjustHeight;
    const firstSubmenu = that.find($(".c-main-navigation__submenu"));
    const isSubmenuParent = that
      .offsetParent()
      .attr("class")
      .split(" ")
      .includes("c-main-navigation__submenu");

    if (isSubmenuParent) {
      return;
    }

    if (firstSubmenu.css("display") == "flex") {
      return;
    }

    closeSubnavOnDocument(firstSubmenu);

    if (firstSubmenu && isDesktop) {
      firstSubmenu.css("top", `${headerHeight}px`);
      firstSubmenu
        .css("display", "flex")
        .hide()
        .fadeIn(150);
    }

    that.addClass(constants.listActive);
  };

  opanSubNav.on("mouseenter", e => {
    if (nodeTimeout) {
      clearTimeout(nodeTimeout);
      nodeTimeout = null;
    }

    openSubNavFv(e);
  });

  opanSubNav.on("mouseleave", e => {
    if (e.target != openSubNavUl[0] && e.target != openSubNavUl[1]) {
      return;
    }

    if (!nodeTimeout) {
      nodeTimeout = setTimeout(function() {
        closeSubnavOnDocument();
      }, 500);
    }
  });

  $(document).on("click", closeSubnavOnDocument);
};

$(window).resize(() => {
  checkDevices();
  initMenuDesktop();
});

$(window).ready(() => {
  checkDevices();
  initMenuDesktop();
});
